import React from 'react';
import { FaithCircleCandleIcon } from './faith-circle-candle-icon';
import { TopicCardDivider, TopicCardTitle, TOPIC_CARD_ICON_2 } from './topic-card-shared';

import faithPersonImage from './faith-person.webp';

interface FaithTopicCardProps {
  title: string;
  className?: string;
}

export const FaithTopicCard: React.FC<FaithTopicCardProps> = ({ title, className = '' }) => (
  <div
    className={`flex w-full min-w-0 flex-col items-center justify-center overflow-hidden rounded-xl bg-white px-2 pb-4 pt-3 sm:px-4 sm:pb-8 sm:pt-6 ${className}`}
  >
    <div className="mt-1 flex w-full flex-col items-center sm:mt-2">
      <div className="relative flex items-start justify-center">
        <div className="absolute left-2 h-[74px] w-[74px] shrink-0 sm:left-1 sm:h-[120px] sm:w-[120px]">
          <FaithCircleCandleIcon fill={TOPIC_CARD_ICON_2} className="h-full w-full" />
        </div>
        <img
          src={faithPersonImage}
          alt=""
          className="relative z-10 ml-12 aspect-[87/128] w-[67px] shrink-0 object-cover object-top sm:ml-16 sm:w-[100.595px]"
        />
      </div>
      <TopicCardDivider />
    </div>
    <TopicCardTitle title={title} />
  </div>
);
